// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 791 ? "materials" : chunkId) + "." + {"453":"162362da","719":"976978a2","791":"d4b2bf24","804":"c49fde03"}[chunkId] + ".css";
};